// eslint-disable-next-line
import React from "react";
import { appInsights } from "./src/components/AppInsights/AppInsights";

import LocaleWrap from "./wrapPageElement";

appInsights.loadAppInsights();

export const wrapPageElement = LocaleWrap;
